<template>
  <div id="app">

    <div class="body-content hg-page-width">
      <router-view />
    </div>

    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "assets/css/common.css";
#app {
  margin: auto;
  position: relative;
}
.body-content {
  margin: auto;
  display: grid;
  grid-template-rows: auto 200px;
  grid-template-columns: 100%;
  grid-auto-flow: column;
  justify-items: stretch;
  justify-content: center;
}
/**超大屏*/
@media screen and (min-width: 1226px) {
}
/** iPad **/
@media only screen and (min-width: 768px) and (max-width: 1024px) {
}
/** iPhone **/
@media only screen and (min-width: 320px) and (max-width: 767px) {
}
</style>



// WEBPACK FOOTER //
// src/App.vue